import React from 'react';
import { LogoKalash, LogoMonogram, LogoOilBottle, LogoPickleJar, LogoShieldWheat, LogoMinimalH } from '../components/LogoOptions';

const LogoShowcase = () => {
  const logos = [
    { 
      id: 1, 
      name: 'Traditional Kalash', 
      description: 'Current logo - Traditional pot with grain symbolizing prosperity',
      Component: LogoKalash,
      recommended: true
    },
    { 
      id: 2, 
      name: 'HB Monogram', 
      description: 'Elegant "HB" letters with wheat accent - Modern & Premium',
      Component: LogoMonogram,
      recommended: false
    },
    { 
      id: 3, 
      name: 'Mustard Oil Bottle', 
      description: 'Oil bottle with golden drop - Product-focused design',
      Component: LogoOilBottle,
      recommended: false
    },
    { 
      id: 4, 
      name: 'Pickle Jar', 
      description: 'Traditional pickle jar - Heritage & Authentic feel',
      Component: LogoPickleJar,
      recommended: false
    },
    { 
      id: 5, 
      name: 'Shield with Wheat', 
      description: 'Royal shield with wheat crown - Trust & Quality',
      Component: LogoShieldWheat,
      recommended: false
    },
    { 
      id: 6, 
      name: 'Minimal H', 
      description: 'Clean stylized "H" - Modern & Minimalist',
      Component: LogoMinimalH,
      recommended: false
    },
  ];

  return (
    <div className="min-h-screen bg-[#FDF6E3] pt-24 pb-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="font-serif text-4xl sm:text-5xl font-bold text-[#5C3D2E] mb-4">
            Logo Options
          </h1>
          <p className="text-[#5C3D2E]/70 max-w-2xl mx-auto">
            Choose your preferred logo design for House of Bania. Each design represents different aspects of your heritage brand.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {logos.map((logo) => (
            <div 
              key={logo.id}
              className={`relative bg-white rounded-2xl p-8 shadow-lg border-2 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 ${
                logo.recommended ? 'border-[#C17817]' : 'border-[#D4A853]/20 hover:border-[#C17817]/50'
              }`}
            >
              {logo.recommended && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#C17817] text-white text-xs font-bold px-4 py-1 rounded-full">
                  CURRENT
                </div>
              )}
              
              {/* Logo Display */}
              <div className="flex justify-center mb-6">
                <div className="p-4 bg-[#FDF6E3] rounded-2xl">
                  <logo.Component className="w-24 h-24 drop-shadow-lg" />
                </div>
              </div>

              {/* Logo in Header Preview */}
              <div className="bg-[#3D2314] rounded-xl p-4 mb-6">
                <div className="flex items-center gap-3">
                  <logo.Component className="w-12 h-12" />
                  <div>
                    <span className="font-serif text-lg font-bold text-[#FDF6E3]">House of Bania</span>
                    <p className="text-[10px] text-[#D4A853] tracking-wider">Heritage Taste</p>
                  </div>
                </div>
              </div>

              {/* Info */}
              <div className="text-center">
                <h3 className="font-serif text-xl font-bold text-[#5C3D2E] mb-2">
                  Option {logo.id}: {logo.name}
                </h3>
                <p className="text-sm text-[#5C3D2E]/60">
                  {logo.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Selection Info */}
        <div className="mt-12 text-center p-6 bg-[#C17817]/10 rounded-2xl border border-[#C17817]/20">
          <p className="text-[#5C3D2E] font-medium">
            Tell me which logo option you prefer (1-6), and I'll update the website with your choice!
          </p>
        </div>
      </div>
    </div>
  );
};

export default LogoShowcase;
